'use strict';

var TrendChart = function TrendChart(AbstractChart, chartContainers, chartGroups, chartBarSeries, chartYAxis, chartXAxis, formatterService, chartConstants, chartVerticalLine) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var chartContainerScalesBuilder = require('./ContainerScales');
  var containerXAxisRotation = chartConstants.AXIS.SKEW.DEG_30;
  containerXAxisRotation.transform = 'translate(8,0)' + containerXAxisRotation.transform;
  var config = {
    verticalLineOffsetX: 0,
    verticalLineOffsetXWithinContainer: 0,
    xAxisLabelRotation: containerXAxisRotation
  };
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var groups = chartGroups('d1', formatters.tooltipFormatter);
    var m1m2Bars = chartBarSeries(['m1', 'm2']);
    var yAxis = chartYAxis(formatterService.humanReadable, chartConstants.AXIS.MODE.LEFT);
    var xAxis = chartXAxis(formatters.xAxis).withoutLine().withTextRotation(0).withRepetition(1);
    var containerXAxis = chartXAxis(formatters.xAxisContainer).withTextRotation(chartConstants.AXIS.SKEW.DEG_90).withRepetition(1);
    var verticalLine = chartVerticalLine().withSize(chartConstants.VERTICAL_LINE.SIZE.CONTAINER).withStrokeWidth(1).withOpacity(1).withLastLine(true);
    var verticalLineForContainer = chartVerticalLine().withStrokeWidth(1).withOpacity(1).withFirstLine(false);
    this.render = function (data) {
      var chartParamsInstance = chartParams(-config.verticalLineOffsetX);
      this.initChart(data, [0, data.length], chartParamsInstance);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      verticalLine.withOffsetX(config.verticalLineOffsetX);
      verticalLineForContainer.withOffsetX(config.verticalLineOffsetXWithinContainer);
      containerXAxis.withTextRotation(config.xAxisLabelRotation);
      var chartContainerScales = chartContainerScalesBuilder(this.scales.yScale);
      var containers = chartContainers('d1', [groups, verticalLineForContainer, m1m2Bars, containerXAxis], chartContainerScales);
      this.callForDataGroup([yAxis, verticalLine, containers, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
TrendChart.$inject = ['AbstractChart', 'ChartElementsContainer', 'ChartElementsGroup', 'ChartElementsBarSeries', 'ChartElementsYAxis', 'ChartElementsXAxis', 'FormatterService', 'ChartElementsConstants', 'ChartElementsVerticalLine'];
module.exports = TrendChart;